import {createTheme} from '@mui/material/styles';

const StyledTheme = createTheme({});

export default StyledTheme;
